import { render, staticRenderFns } from "./AccountManager.vue?vue&type=template&id=384dd814&"
import script from "./AccountManager.vue?vue&type=script&lang=js&"
export * from "./AccountManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports